import React from "react";
import { Container } from "react-bootstrap";
import "./Home.css"
const About = () => {
  return (
    <div className="about">
      <Container>
        <h1  style={{ textAlign: "center", color: "black" }}> About Us</h1>
      </Container>
    </div>
  );
};

export default About;
